export default __webpack_public_path__ + "static/media/img7.9239bd80.jpg";